import {isNotNil} from 'ramda';
import {isString} from 'ramda-adjunct';

import {UpdateWatermarkV2RequestBody, WatermarkPositionEnum} from '@dms/api/shared';

import {WatermarkFormType} from '../types/WatermarkFormType';

// A composition is rendered server-side into the whole watermark image, so the BE forces the
// placement to a full-size centered fit; the request mirrors that instead of sending stale values.
const COMPOSITION_PLACEMENT: Pick<
  UpdateWatermarkV2RequestBody,
  'position' | 'size' | 'fitToImage'
> = {
  position: 'center_center',
  size: 100,
  fitToImage: true,
};

export const getRequestData = (data: WatermarkFormType): UpdateWatermarkV2RequestBody => {
  const placement = isNotNil(data.composition)
    ? COMPOSITION_PLACEMENT
    : {
        position: data.position as WatermarkPositionEnum,
        size: data.size,
        fitToImage: data.fitToImage,
      };

  return {
    name: data.name,
    ...placement,
    usageType: data.usageType,
    fileId: (isString(data.fileId) ? data.fileId : data.fileId?.id) ?? null,
    composition: data.composition,
  };
};
